import { setReadMoreListeners } from './shared/read-more.ts';
setReadMoreListeners();
